

export const getLogisticsRole = (): string | null => {
  try {
    const role = localStorage.getItem("roles");
    return role;
  } catch (err) {
    console.log(err, "Error");
    return null;
  }
};

export const getLogisticsToken = (): string | null => {
  try {
    const accessToken = localStorage.getItem("roles");
    return accessToken;
  } catch (err) {
    console.error("No data found in localStorage for the given key.");
    return null;
  }
};
